import { type ComputeRequirements } from "./ActionRecord";

export const actionStorageMin = 21;
export const actionStorageMax = 200;
export const vCpuOptions = [256, 512, 1024, 2048, 4096, 8192, 16384];

export const determineActionMemoryOptions = (cpu: string) => {
  function range(start: number, stop: number, step: number) {
    const a = [start];
    let b = start;
    while (b < stop) {
      a.push((b += step || 1));
    }
    return a;
  }

  const vCPU = parseInt(cpu);

  switch (vCPU) {
    case 256:
      return [512, 1024, 2048];
    case 512:
      return range(1024, 4 * 1024, 1024);
    case 1024:
      return range(2 * 1024, 8 * 1024, 1024);
    case 2048:
      return range(4 * 1024, 16 * 1024, 1024);
    case 4096:
      return range(8 * 1024, 30 * 1024, 1024);
    case 8192:
      return range(16 * 1024, 60 * 1024, 4 * 1024);
    case 16384:
      return range(32 * 1024, 120 * 1024, 8 * 1024);
  }
  return [];
};

export const parseComputeRequirements = (
  cpu: string | undefined,
  memory: string | undefined,
  gpu: string | undefined,
  storage: number | undefined,
) => {
  const computeRequirements = {} as ComputeRequirements;

  if (!cpu && !memory && !gpu && !storage) {
    return null;
  }

  if (cpu !== undefined) {
    computeRequirements.vCPU = parseInt(cpu);
  }
  if (memory !== undefined) {
    computeRequirements.memory = parseInt(memory);
  }
  if (gpu !== undefined) {
    computeRequirements.gpu = gpu === "true";
  }
  if (storage !== undefined) {
    computeRequirements.storage = storage;
  }

  return computeRequirements;
};
